var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1254 11.8472L10.3598 7.6753C10.3318 7.65496 10.2987 7.64277 10.2641 7.64009C10.2296 7.63741 10.195 7.64434 10.1642 7.66012C10.1334 7.67589 10.1075 7.6999 10.0895 7.72947C10.0715 7.75904 10.062 7.79302 10.0621 7.82764V8.92686C10.0621 9.16592 10.177 9.39327 10.3715 9.53389L13.7793 11.9995L10.3715 14.4651C10.177 14.6058 10.0621 14.8308 10.0621 15.0722V16.1714C10.0621 16.3237 10.2356 16.4128 10.3598 16.3237L16.1254 12.1519C16.2285 12.0769 16.2285 11.9222 16.1254 11.8472Z",
    fill: "#52C41A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5C6.70156 1.5 2 6.20156 2 12C2 17.7984 6.70156 22.5 12.5 22.5C18.2984 22.5 23 17.7984 23 12C23 6.20156 18.2984 1.5 12.5 1.5ZM12.5 20.7188C7.68594 20.7188 3.78125 16.8141 3.78125 12C3.78125 7.18594 7.68594 3.28125 12.5 3.28125C17.3141 3.28125 21.2188 7.18594 21.2188 12C21.2188 16.8141 17.3141 20.7188 12.5 20.7188Z",
    fill: "#52C41A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.0013890e1e31d71f5d3c8e59364e7509.svg";
export { ForwardRef as ReactComponent };